import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiResult } from 'services/InvoiceService'
import { historyRecordsApi } from 'services/RateCardService'

export const getData = createAsyncThunk(
    'approvedInvoices/data/getData',
    async (data) => {
        const response = await historyRecordsApi(data)
        return response.data
    },
)

export const getResult = createAsyncThunk(
    'approvedInvoices/data/getResult',
    async (data) => {
        const response = await getApiResult(data)
        return response.data
    },
)

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    selectedTab: 'Approved',
    sort: [{ column: '', dir: '' }],
    startDate: null,
    endDate: null,
}

const dataSlice = createSlice({
    name: 'approvedInvoices/data',
    initialState: {
        loading: false,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getData.pending, (state) => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, (state) => {
                state.loading = false
                state.data = []
            })

            //Result
            .addCase(getResult.pending, (state) => {
                state.loading = true
                state.result = null
            })
            .addCase(getResult.fulfilled, (state, { payload }) => {
                state.loading = false
                state.result = payload
            })
            .addCase(getResult.rejected, (state) => {
                state.loading = false
                state.result = null
            })
    },
})

export const { setData, setTableData } = dataSlice.actions

export default dataSlice.reducer
